import { reviews } from "@/mocks/kanliao";

const tintMap: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export default function Reviews() {
  return (
    <section id="stories" className="container-px py-16 md:py-24">
      <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
        <span className="section-title">用户评价</span>
        <h2 className="heading mt-4">快人一步的订阅者怎么说</h2>
        <p className="prose-p mt-4">
          真实使用者的口碑，是订阅提醒是否可靠的最佳证明。来看看他们如何借助推送通知不错过每一次更新。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
        {reviews.map((review) => (
          <figure
            key={review.name}
            className="flex flex-col justify-between rounded-2xl border border-background-200/70 bg-background-50 p-6"
          >
            <div>
              <i
                className="ri-chat-quote-fill text-3xl text-secondary-300"
                aria-hidden="true"
              ></i>
              <blockquote className="mt-3 text-sm leading-7 text-foreground-700">
                “{review.quote}”
              </blockquote>
            </div>
            <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200/60 pt-4">
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-full font-heading text-lg font-bold text-background-50 ${
                  tintMap[review.tint] || "bg-primary-500"
                }`}
                aria-hidden="true"
              >
                {review.initials}
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  {review.name}
                </div>
                <div className="text-xs text-foreground-500">{review.role}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}